'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const react = require('@emotion/react');
const components_marketing_SubscriptionForm_SubscriptionForm = require('./SubscriptionForm.cjs.js');
const components_marketing_SubscriptionForm_DisclaimerText = require('./DisclaimerText.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = {
  ctaContainer: react.css`
    ${styleMixins_reset.boxSizing};
    text-align: center;
    display: flex;
    align-items: stretch;
    flex-direction: column;
    text-align: left;
  `
};
const SubscriptionFormWithDisclaimer = (_a) => {
  var { disclaimerTextColor = "primary", disclaimerTextType } = _a, restProps = tslib_es6.__rest(_a, ["disclaimerTextColor", "disclaimerTextType"]);
  return react.jsx(
    "div",
    { css: Styles.ctaContainer, "data-zds": true },
    react.jsx(components_marketing_SubscriptionForm_SubscriptionForm.SubscriptionForm, Object.assign({}, restProps, { fluidInput: true })),
    react.jsx(components_marketing_SubscriptionForm_DisclaimerText.DisclaimerText, { color: disclaimerTextColor, textType: disclaimerTextType })
  );
};

exports.SubscriptionFormWithDisclaimer = SubscriptionFormWithDisclaimer;
//# sourceMappingURL=SubscriptionFormWithDisclaimer.cjs.js.map
